import { Link } from 'react-admin';
import { Breadcrumbs as MuiBreadcrumbs, Typography } from '@mui/material';

interface BreadcrumbItem {
  label: string;
  to?: string;
}

export const AppBreadcrumbs = ({ items }: { items: BreadcrumbItem[] }) => (
  <MuiBreadcrumbs aria-label="breadcrumb" sx={{ mb: 1, fontSize: '0.85rem' }}>
    {items.map((item, i) =>
      item.to && i < items.length - 1 ? (
        <Link key={i} to={item.to} sx={{ color: 'inherit', textDecoration: 'underline' }}>
          {item.label}
        </Link>
      ) : (
        <Typography
          key={i}
          color={i === items.length - 1 ? 'text.primary' : 'text.secondary'}
          variant="inherit"
        >
          {item.label}
        </Typography>
      )
    )}
  </MuiBreadcrumbs>
);
